import Actions from "../actions";
import { produce } from "immer";

const initialState = {
    superAdminServices: {}
};


const superAdminServices = produce((draft = initialState, action) => {
  const { payload } = action;
  switch (action.type) {
    case Actions.GET_SUPER_ADMIN_SERVICES_LIST: {
      draft.superAdminServices = payload?.superAdminServices;
      break;
    }

    default: {
      break;
    }
  }
}, initialState);

export default superAdminServices;